import React, { useCallback } from "react";
import { wasSearchInteractionSuccessful } from "../analytics/interactions";
import { AnalyticsEvent } from "../analytics/track";
import { useAnalytics } from "../hooks/analytics";
import { useDialogTriggers } from "../hooks/use_dialog_triggers";
import { useConfig } from "../providers/config_provider";
import { useDialogState } from "../providers/dialog_state_provider";
import { useSearchQuery } from "../providers/search_query_provider";
import SearchContainer from "./container";

export default function SearchDialog() {
  // Initialize the analytics hook
  const { triggerId } = useConfig();
  const { track, updateSearchInteractionId, clearSearchInteractionId } = useAnalytics();
  const { isOpen, openDialog, closeDialog } = useDialogState();
  const { normalizedQuery } = useSearchQuery();

  const handleOpenDialog = useCallback(() => {
    updateSearchInteractionId();
    track(AnalyticsEvent.SEARCH_WIDGET_CLICKED);
    openDialog();
  }, [track, updateSearchInteractionId, openDialog]);
  const dialogRef = useDialogTriggers({ isOpen, open: handleOpenDialog, triggerId });

  return (
    <dialog
      id="dewey--search--dialog"
      ref={dialogRef}
      onClose={() => {
        if (!wasSearchInteractionSuccessful()) {
          track(AnalyticsEvent.SEARCH_ABANDONED, { query: normalizedQuery, query_type: undefined });
        }
        clearSearchInteractionId();
        closeDialog();
      }}
      onClick={(event) => {
        // Close the dialog if the user clicks outside the dialog
        if (event.target instanceof HTMLElement && event.target.id === "dewey--search--dialog") {
          closeDialog();
        }
      }}
      className="dewey--search--dialog"
    >
      {/* Wrapper is needed to properly detect clicks outside the dialog */}
      {isOpen && (
        <div className="dewey--search--page">
          <SearchContainer />
        </div>
      )}
    </dialog>
  );
}
